import { render } from "./LowTimeWarning.vue?vue&type=template&id=af38847e"
import script from "./LowTimeWarning.vue?vue&type=script&lang=js"
export * from "./LowTimeWarning.vue?vue&type=script&lang=js"
script.render = render

export default script